import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

export interface AlertDialogData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-alert-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule
  ],
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})
export class AlertDialogComponent {

  isJson: boolean = false;
  jsonData: any;

  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlertDialogData
  ) {
    this.detectJson(data?.message);
  }

  detectJson(message: any) {
    if (typeof message === 'object') {
      this.isJson = true;
      this.jsonData = JSON.stringify(message, null, 2);
      return;
    }

    try {
      const parsed = JSON.parse(message);
      this.jsonData = JSON.stringify(parsed, null, 2);
      this.isJson = true;
    } catch {
      this.isJson = false;
    }
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}
